import { Grid } from "@mui/material";
import { memo } from "react";
import { useFormContext } from "react-hook-form";

import { CollapsibleCard } from "@/components/elements/CollapsibleCard";
import { FormField } from "@/modules/irohana-components/elements/FormField";
import { RadioGroup } from "@/modules/irohana-components/elements/RadioGroup";
import { BILLING_TREATMENT_OPTIONS } from "@/features/organization/invoice/constants/invoiceEnums";
import { TInvoiceForm } from "@/features/organization/invoice/types/InvoiceForm";

type TBillingTreatmentSectionProps = {
  title: string;
  leftName: keyof TInvoiceForm;
  leftLabel: string;
  rightName: keyof TInvoiceForm;
  rightLabel: string;
};

/**
 * Shared layout for 入退社月情報 と 一時帰国・休職情報 — a card with two side-by-side
 * 全額請求する / 請求しない / 日割り radio groups.
 */
export const BillingTreatmentSection = memo(({ title, leftName, leftLabel, rightName, rightLabel }: TBillingTreatmentSectionProps) => {
  const { control } = useFormContext<TInvoiceForm>();

  return (
    <CollapsibleCard title={title}>
      <Grid container columnSpacing={3} rowSpacing={2}>
        <Grid item xs={12} md={6}>
          <FormField control={control} name={leftName} label={leftLabel} required>
            <RadioGroup options={BILLING_TREATMENT_OPTIONS} direction="row" />
          </FormField>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField control={control} name={rightName} label={rightLabel} required>
            <RadioGroup options={BILLING_TREATMENT_OPTIONS} direction="row" />
          </FormField>
        </Grid>
      </Grid>
    </CollapsibleCard>
  );
});

BillingTreatmentSection.displayName = "BillingTreatmentSection";
